import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as partnerApi from '../../lib/api/partner';

const [
  LIST_PARTNER_PRODUCT_PRICES,
  LIST_PARTNER_PRODUCT_PRICES_SUCCESS,
  LIST_PARTNER_PRODUCT_PRICES_FAILURE,
] = createRequestActionTypes('partner/LIST_PARTNER_PRODUCT_PRICES');

export const listPartnerProductPrices = createAction(
  LIST_PARTNER_PRODUCT_PRICES,
  (searchData) => searchData,
);
const listPartnerProductPricesSaga = createRequestSaga(
  LIST_PARTNER_PRODUCT_PRICES,
  partnerApi.getProductPriceByPartner,
);

const UNLOAD_PARTNER_PRODUCT_PRICES = 'partner/UNLOAD_PARTNER_PRODUCT_PRICES';
export const unloadPartnerProductPrices = createAction(UNLOAD_PARTNER_PRODUCT_PRICES);

export function* partnerProductPricesSaga() {
  yield takeLatest(LIST_PARTNER_PRODUCT_PRICES, listPartnerProductPricesSaga);
}

const initialState = {
  productprices: null,
  error: null,
};

const partnerProductPrices = handleActions(
  {
    [LIST_PARTNER_PRODUCT_PRICES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      productprices: data.list.map((pp) => ({
        id: pp.priceUuid,
        pricePartnerUuid:pp.pricePartnerUuid,//매입처
        productUuid:pp.productUuid,
        productNm:pp.productNm,
        modelNm:pp.modelNm,
        partnerNm:pp.partnerNm,//제조업체
        category:pp.category,
        priceTyp:pp.priceTyp,
        priceVal:pp.priceVal,
        priceDesc:pp.priceDesc,
        useYn:pp.priceUseYn,
        crtDt:pp.crtDt,
        crtNm:pp.crtNm,
        cngDt:pp.cngDt,
        cngNm:pp.cngNm,
      })),
      error: null,
    }),
    [LIST_PARTNER_PRODUCT_PRICES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PARTNER_PRODUCT_PRICES]: () => initialState,
  },
  initialState,
);

export default partnerProductPrices;
